/**
 * Shared utility functions for Regtank operations
 */

/**
 * Sorts array by expiredDate descending (most recent first)
 * Generic function that works with any object containing expiredDate
 */
export const sortByExpiryDateDesc = <T extends { expiredDate: string | Date }>(
  items: T[]
): T[] => {
  return [...items].sort(
    (a, b) =>
      new Date(b.expiredDate).getTime() - new Date(a.expiredDate).getTime()
  );
};
